// extracted by mini-css-extract-plugin
export default {"container":"DeckPage_container__Mmz0p","mainContainer":"DeckPage_mainContainer__kfk8u"};